import MicroModal from 'micromodal';
import Swiper from 'swiper';
import { Navigation, A11y, FreeMode } from 'swiper/modules';
import loadProductsByID from '../../core/storefrontAPI/load-product-by-id';
import sliderADA from '../../components/slider/ada';
import addToCart from '../slider-cart/addToCart';

export default class Gift {
  threshold;
  cartData;
  giftData;
  giftCardId;

  constructor() {
    this.threshold = window.theme.customer?.loyalty_gift_threshold || 0;
    this.cartData = window?.theme?.cart?.data;
    this.giftData = [];
    this.giftCardId = 391067893787;

    if (/*typeof window.theme.customer.id !== 'undefined' &&*/ window.theme.customer?.loyalty_gifts && window.theme.customer?.loyalty_gifts.length && this.threshold > 0) {
      this.openGiftModal();
    }
  }

  retrieveCartData = async () => {
    this.cartData = await fetch('/cart.js').then(response => response.json());
  };

  retrieveAvailableGifts = async () => {
    const gift_products = await loadProductsByID(window.theme.customer?.loyalty_gifts);

    if (!gift_products.length) {
      this.giftData = [];
      return;
    }

    this.giftData = gift_products.filter(product => product.available);

    // Split variants by color
    this.giftData.forEach(product => {
      product.variants = product.variants.reduce((acc, variant) => {
        const color = variant.color;
        if (color) {
          acc[color] = acc[color] || [];
          acc[color].push(variant);
        }
        return acc;
      }, {});
    });

    // If all variants from the same color are sold out, remove the color from the gift data
    this.giftData.forEach(product => {
      product.variants = Object.fromEntries(
        // Check if at least one variant is available
        Object.entries(product.variants).filter(([color, variants]) => variants.some(variant => variant.available))
      );
    });
  };

  buildProductsHtml = () => {
    let html = '';

    this.giftData.forEach(product => {
      Object.entries(product.variants).forEach(([color, variants]) => {
        // Find the first available variant to display image and init the dropdown
        const firstVariant = variants.find(v => v.available) || variants[0];
        const image = firstVariant.image || product.featured_image;

        // Image
        let imageHtml = '';
        if (image) {
          imageHtml = `
            <div class="product-card__image-wrapper">
              <img class="product-card__image" alt="${product.title}" src="${image.replace('.jpg', '_220x340@2x.jpg')}" onError="this.onerror=null; this.src='${window.theme.productTiles.placeholder}';" />
            </div>
          `;
        }

        // Title and Color
        const titleHtml = `<h3 class="product-card__title">${product.title}</h3>`;
        const colorHtml = `<p class="product-card__color">Color: <span>${color}</span></p>`;

        // Sizes Dropdown
        let optionsHtml = '';
        variants.forEach(variant => {
          optionsHtml += `<option value="${variant.id}" ${(!variant.available) ? 'disabled' : ''}>${variant.size}</option>`;
        });

        const selectHtml = `
          <div class="product-card__form">
            <select class="product-card__select" aria-label="Select size">
              ${optionsHtml}
            </select>
          </div>
        `;

        // Add to Cart Button
        const buttonHtml = `
          <button
            type="button"
            class="btn btn--primary product-card__add-to-cart"
            data-add-to-cart-gift
            data-variant-id="${firstVariant.id}"
          >
            ADD TO BAG
          </button>
        `;

        html += `
          <div class="product-card swiper-slide">
            <div class="product-card__image">
              <a href="${window.Shopify.routes.root}products/${product.handle}" target="_blank">${imageHtml}</a>
            </div>
            <div class="product-card__info">
              ${titleHtml}
              ${colorHtml}
              ${selectHtml}
              ${buttonHtml}
            </div>
          </div>
        `;
      });
    });

    return html;
  };

  // showCustomMessages = (subtotal) => {
  //   if (document.querySelectorAll('[data-gwp-message]').length && document.querySelector('[data-gwp-message="1"]') && document.querySelector('[data-gwp-message="2"]')) {
  //     if (subtotal < this.threshold) {  
  //       document.querySelector('[data-gwp-message="1"]').classList.remove('visually-hidden');
  //       document.querySelector('[data-gwp-message="2"]').classList.add('visually-hidden');
  //     } else {
  //       document.querySelector('[data-gwp-message="2"]').classList.remove('visually-hidden');
  //       document.querySelector('[data-gwp-message="1"]').classList.add('visually-hidden');
  //     }
  //   }
  // };

  openGiftModal = async () => {
    console.log('[GWP] openGiftModal');

    if (!this.cartData) {
      await this.retrieveCartData();
    }

    // const subtotal = this.cartData.total_price / 100;
    const subtotal = this.cartData.items.reduce((acc, item) => {
      if (item.product_id === this.giftCardId) return acc;
      return acc + item.final_line_price;
    }, 0) / 100;

    console.log('[GWP] subtotal', subtotal);

    // Show custom message on cart and pdp banner
    // this.showCustomMessages(subtotal);

    // Make sure the customer doesn't have the gift in cart already
    let hasGiftInCart = false;
    const giftIds = window.theme.customer?.loyalty_gifts || [];
    this.cartData.items.forEach(item => {
      if (giftIds.some(id => id == item.product_id) && item.properties && item.properties['_GWP']) {
        hasGiftInCart = true;
      }
    });

    if (hasGiftInCart) {
      console.log('[GWP] hasGiftInCart');
      return;
    }

    if (subtotal < this.threshold) {
      console.log('[GWP] subtotal < threshold');
      return;
    }

    const gift_modal = document.querySelector('[data-gift-modal]');

    if (gift_modal) {
      await this.retrieveAvailableGifts();
      const products_wrapper = gift_modal.querySelector('[data-products-wrapper] .swiper-wrapper');

      console.log('[GWP] giftData', this.giftData);

      if (!this.giftData.length || !products_wrapper) {
        return;
      }

      const products_html = this.buildProductsHtml();

      MicroModal.show(gift_modal.id, {
        disableScroll: true,
        awaitOpenAnimation: true,
        awaitCloseAnimation: true,
        onShow: async (modal) => {
          console.log('[GWP] modal opened', subtotal, this.threshold, this.giftData);
          products_wrapper.innerHTML = products_html;

          products_wrapper.querySelectorAll('.product-card__add-to-cart').forEach(btn => {
            btn.addEventListener('click', (e) => {
              e.preventDefault();
              const card = btn.closest('.product-card');
              const select = card.querySelector('select');
              const variantId = select.value;

              if (variantId) {
                const originalText = btn.textContent;
                btn.textContent = 'Adding...';
                btn.disabled = true;

                addToCart(`id=${variantId}&quantity=1&properties[_GWP]=true`, '/cart');

                /*
                addToCart(`id=${variantId}&quantity=1&properties[_GWP]=true`).then(success => {
                   btn.disabled = false;
                   if (success) {
                     btn.textContent = 'Added';
                     setTimeout(() => {
                       btn.textContent = originalText;
                     }, 2000);
                     // Close the modal on successful add, as the cart drawer will likely open
                     const modal = document.getElementById('gift-modal');
                     if (modal) { 
                         const closeBtn = modal.querySelector('.modal__close');
                         if(closeBtn) closeBtn.click();
                     }
                   } else {
                     btn.textContent = 'Error';
                     setTimeout(() => {
                       btn.textContent = originalText;
                     }, 2000);
                   }
                });
                */
              }
            });
          });

          new Swiper('[data-products-wrapper] .swiper-container', {
            modules: [Navigation, A11y, FreeMode],
            a11y: {
              enabled: true,
              wrapperLiveRegion: false,
              prevSlideMessage: 'Previous slide',
              nextSlideMessage: 'Next slide',
            },
            slidesPerView: 1.5,
            slidesPerGroup: 1,
            spaceBetween: 10,
            loop: true,
            loopAddBlankSlides: false,
            autoHeight: true,
            freeMode: true,
            autoplay: false,
            cssMode: false,
            centeredSlides: false,
            navigation: {
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev',
            },
            breakpoints: {
              769: {
                slidesPerView: 2.3,
                slidesPerGroup: 3,
                freeMode: false,
              },
            },
            on: {
              init: function () {
                // Swiper's a11y module sets aria-label on this container but not a
                // role, so on a plain <div> (implicit role="generic") the label is
                // silently ignored by assistive tech.
                this.el.setAttribute('role', 'region');
                sliderADA(this);

                const positionArrows = () => {
                  const firstSlide = this.slides[0];
                  if (!firstSlide) return;
                  const image = firstSlide.querySelector('img');
                  if (image) {
                    const height = image.offsetHeight;
                    if (height > 0) {
                      this.el.querySelectorAll('.swiper-arrow').forEach(arrow => {
                        arrow.style.top = `${height / 2}px`;
                      });
                    } else {
                      // Image might not be loaded yet
                      image.onload = () => positionArrows();
                    }
                  }
                };

                positionArrows();
                this.on('resize', positionArrows);
              },
            },
          });
        },
      });
    }
  };
}
